"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _dayjs = _interopRequireDefault(require("dayjs"));

require("react-datepicker/dist/react-datepicker.css");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTimes = require("@fortawesome/pro-regular-svg-icons/faTimes");

var _peractoUi = require("@peracto/peracto-ui");

var _excluded = ["name", "label", "help", "className", "showWhen", "required", "defaultValue", "rawDate", "setTime", "format", "allowClear", "fullWidth", "includeTime", "disabled"];

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledDateInput = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .full-width-wrapper {\n        .react-datepicker-wrapper {\n            display: block;\n            width: 100%;\n        }\n    }\n"])));

var DateInput = function DateInput(_ref) {
  var name = _ref.name,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      help = _ref.help,
      className = _ref.className,
      showWhen = _ref.showWhen,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? null : _ref$required,
      defaultValue = _ref.defaultValue,
      _ref$rawDate = _ref.rawDate,
      rawDate = _ref$rawDate === void 0 ? false : _ref$rawDate,
      setTime = _ref.setTime,
      format = _ref.format,
      _ref$allowClear = _ref.allowClear,
      allowClear = _ref$allowClear === void 0 ? false : _ref$allowClear,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$includeTime = _ref.includeTime,
      includeTime = _ref$includeTime === void 0 ? false : _ref$includeTime,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(StyledDateInput, null, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name
  }, function (_ref2) {
    var field = _ref2.field,
        form = _ref2.form;
    var error = (0, _formik.getIn)(form.errors, name);

    if (error) {
      var errorFieldName = label ? label : 'This';
      error = error.replace(field.name, errorFieldName);
    }

    if (showWhen) {
      var showField = form.values.hasOwnProperty(showWhen) ? form.values[showWhen] : false;

      if (!showField) {
        return null;
      }
    }

    props.className = (0, _classnames["default"])('form-control', className);

    if (help) {
      props['aria-describedby'] = "".concat(name, "Help");
    }

    return /*#__PURE__*/_react["default"].createElement(_peractoUi.FormGroup, {
      name: name,
      label: label,
      help: help,
      required: required,
      error: error
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])({
        'full-width-wrapper': fullWidth,
        'd-flex flex-row': allowClear
      })
    }, /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], _extends({
      className: "datepicker__start-date form-control ".concat(className),
      placeholderText: "Select Date...",
      selected: rawDate ? field.value : field.value ? new Date(field.value) : allowClear ? '' : new Date(),
      dateFormat: format || (includeTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy"),
      showTimeSelect: includeTime,
      timeFormat: "HH:mm",
      timeCaption: "Time",
      onChange: function onChange(date) {
        if (date) {
          if (setTime) {
            date = setTime(date);
          }

          if (rawDate) {
            form.setFieldValue(field.name, date);
          } else {
            form.setFieldValue(field.name, (0, _dayjs["default"])(includeTime ? date : date.toDateString()));
          }
        } else {
          form.setFieldValue(field.name, null);
        }
      }
    }, props)), allowClear && /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-link text-nowrap",
      onClick: function onClick(e) {
        e.preventDefault();
        form.setFieldValue(field.name, '');
      },
      disabled: form.isSubmitting || disabled
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faTimes.faTimes,
      className: "mr-2"
    }), "Clear Value")));
  }));
};

DateInput.displayName = 'DateInput';
DateInput.propTypes = {
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string,
  help: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  placeholder: _propTypes["default"].string,
  className: _propTypes["default"].string,
  showWhen: _propTypes["default"].string
};
var _default = DateInput;
exports["default"] = _default;